<template>

    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>

        <p class="text-headline-small">Tipo</p>
        <v-select v-model="properties.tipo_id" :items="baseData.lookup.segmentotipointervento" label="Tipo"
            item-title="label" hide-details class="mb-6" />

    </v-card>

    <SegmentoCommon v-model="properties" />

</template>

<script setup>

import { onMounted } from 'vue'
import SegmentoCommon from "@/reports/components/SegmentoCommon"
import baseData from '@/assets/catalog/TrackerForms.json'


const properties = defineModel()

const props = defineProps({
    "isNew": {
        type: Boolean,
        default: false
    }
})



onMounted(() => { 
  if (props.isNew) {
    loadDefaults()
  }
})


const loadDefaults = () => {
  properties.value.tipo_id = 1
}



</script>
